import { sva } from "@stubhub/broadway-foundation/css";

export const infoBannersRecipe = sva({
  slots: ["wrapper", "row", "col"],
  className: "infoBanners",
  base: {
    wrapper: {
      maxWidth: "[1200px]",
      marginInline: "auto",
      paddingInline: "primitives.200",
      desktop: {
        paddingInline: "primitives.0",
      },
    },
    row: {
      position: "relative",
      /* mobile-first: phone=compact, tablet=reduced, desktop=full */
      paddingBlockStart: "primitives.100",
      tablet: { paddingBlockStart: "primitives.200" },
      desktop: { paddingBlockStart: "primitives.250" },
    },
    col: {
      display: "flex",
      columnGap: "primitives.250",
      "& > div": {
        flexGrow: "1",
        flexShrink: "1",
        flexBasis: "[0%]",
      },
    },
  },
  variants: {
    topSpacing: {
      none: {
        row: {
          paddingBlockStart: "primitives.0",
          tablet: { paddingBlockStart: "primitives.0" },
          desktop: { paddingBlockStart: "primitives.0" },
        },
      },
      default: {},
    },
    childMargin: {
      none: {},
      default: {
        col: {
          "& > div:not(:empty)": {
            marginBlockEnd: "primitives.200",
          },
        },
      },
    },
  },
  defaultVariants: {
    topSpacing: "default",
    childMargin: "default",
  },
});
